/**
 * Cart drawer recommendations:
 * variant image/price sync + quantity % from theme.bundleDiscounts / option data-percent-off
 */
;(function () {
  function money(cents) {
    cents = Math.round(Number(cents) || 0)

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      try {
        return window.theme.formatMoney(cents)
      } catch (e0) {
        /* fall through */
      }
    }

    var format =
      (window.theme && window.theme.moneyFormat) ||
      (window.Shopify && Shopify.money_format) ||
      null

    if (window.Shopify && typeof Shopify.formatMoney === 'function' && format) {
      try {
        return Shopify.formatMoney(cents, format)
      } catch (e) {
        /* fall through */
      }
    }

    try {
      var root = document.querySelector('[data-cart-recs]')
      var locale =
        (root && root.getAttribute('data-locale')) ||
        (window.theme && window.theme.locale) ||
        undefined
      var currency =
        (root && root.getAttribute('data-currency')) ||
        (window.theme && window.theme.currency) ||
        undefined
      if (currency && typeof Intl !== 'undefined') {
        return new Intl.NumberFormat(locale || undefined, {
          style: 'currency',
          currency: currency
        }).format(cents / 100)
      }
    } catch (e2) {
      /* fall through */
    }

    var fallbackCurrency = (window.theme && window.theme.currency) || 'GBP'
    return (cents / 100).toFixed(2) + ' ' + fallbackCurrency
  }

  function getUnitPrice(card) {
    var variantSelect = card.querySelector('[data-cart-rec-variant]')
    if (variantSelect && variantSelect.selectedOptions[0]) {
      var p = parseInt(variantSelect.selectedOptions[0].getAttribute('data-price'), 10)
      if (!isNaN(p)) return p
    }
    var addBtn = card.querySelector('[data-cart-rec-add]')
    if (addBtn && addBtn.getAttribute('data-unit-price')) {
      var u = parseInt(addBtn.getAttribute('data-unit-price'), 10)
      if (!isNaN(u)) return u
    }
    var cardUnit = parseInt(card.getAttribute('data-unit-price'), 10)
    return isNaN(cardUnit) ? 0 : cardUnit
  }

  function getQtyState(card) {
    var qtyMode = card.getAttribute('data-qty-mode') || 'pair'
    var qtyInput = card.querySelector('[data-cart-rec-qty]')
    var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)
    var percentOff = 0

    var discounts = (window.theme && window.theme.bundleDiscounts) || {}
    if (qtyMode === 'pair') {
      if (quantity === 2) percentOff = parseFloat(discounts.shoes2) || 0
      else if (quantity === 3) percentOff = parseFloat(discounts.shoes3) || 0
      else percentOff = 0
    } else {
      // Prefer Product information / theme.bundleDiscounts so cart matches PDP.
      if (quantity === 3) percentOff = parseFloat(discounts.socks3) || 0
      else if (quantity === 6) percentOff = parseFloat(discounts.socks6) || 0
      if (
        !percentOff &&
        qtyInput &&
        qtyInput.selectedOptions &&
        qtyInput.selectedOptions[0]
      ) {
        percentOff =
          parseFloat(qtyInput.selectedOptions[0].getAttribute('data-percent-off') || '0') || 0
      }
    }

    return { quantity: quantity, percentOff: percentOff, qtyMode: qtyMode }
  }

  function syncCard(card) {
    var addBtn = card.querySelector('[data-cart-rec-add]')
    var priceEl = card.querySelector('[data-cart-rec-price]')
    var imageEl = card.querySelector('[data-cart-rec-image]')
    var variantSelect = card.querySelector('[data-cart-rec-variant]')
    var saveBadge = card.querySelector('[data-cart-rec-save-badge]')
    var qtyInput = card.querySelector('[data-cart-rec-qty]')

    var variantId = addBtn && addBtn.getAttribute('data-variant-id')
    var unitPrice = getUnitPrice(card)
    var qtyState = getQtyState(card)

    if (variantSelect) {
      var opt = variantSelect.selectedOptions[0]
      variantId = variantSelect.value
      if (imageEl && opt && opt.getAttribute('data-image')) {
        imageEl.src = opt.getAttribute('data-image')
        var srcset = opt.getAttribute('data-image-srcset')
        var alt = opt.getAttribute('data-image-alt')
        if (srcset) imageEl.srcset = srcset
        if (alt) imageEl.alt = alt
      }
    }

    if (!variantId) {
      if (addBtn) {
        addBtn.disabled = true
        addBtn.removeAttribute('data-variant-id')
      }
      return
    }

    if (addBtn) {
      addBtn.disabled = false
      addBtn.setAttribute('data-variant-id', String(variantId))
      addBtn.setAttribute('data-unit-price', String(unitPrice))
    }

    if (qtyInput) {
      qtyInput.value = String(qtyState.quantity)
      qtyInput.setAttribute('data-percent-off', String(qtyState.percentOff))
    }

    if (saveBadge) {
      if (qtyState.percentOff > 0) {
        saveBadge.hidden = false
        saveBadge.removeAttribute('hidden')
        saveBadge.textContent = 'SAVE ' + qtyState.percentOff + '%'
      } else {
        saveBadge.hidden = true
        saveBadge.setAttribute('hidden', '')
        saveBadge.textContent = ''
      }
    }

    if (priceEl) {
      var discounted =
        window.theme && typeof window.theme.discountedLineCents === 'function'
          ? window.theme.discountedLineCents(unitPrice, qtyState.quantity, qtyState.percentOff)
          : Math.round(unitPrice * qtyState.quantity * (1 - qtyState.percentOff / 100))
      priceEl.textContent = money(discounted)
    }
  }

  function setPairQty(card, qty, percentOff) {
    var qtyInput = card.querySelector('[data-cart-rec-qty]')
    if (qtyInput) {
      qtyInput.value = String(qty)
      qtyInput.setAttribute('data-percent-off', String(percentOff || 0))
    }
    card.querySelectorAll('[data-cart-rec-qty-pill]').forEach(function (pill) {
      var active = String(pill.getAttribute('data-qty')) === String(qty)
      pill.classList.toggle('is-active', active)
      pill.setAttribute('aria-pressed', active ? 'true' : 'false')
    })
    syncCard(card)
  }

  function updateProgress(root) {
    var scroller = root.querySelector('[data-cart-recs-scroller]')
    var bar = root.querySelector('[data-cart-recs-progress]')
    if (!scroller || !bar) return
    var max = scroller.scrollWidth - scroller.clientWidth
    var ratio = max > 0 ? scroller.scrollLeft / max : 0
    bar.style.width = Math.max(20, Math.min(100, 20 + ratio * 80)) + '%'
  }

  function initRoot(root) {
    var scroller = root.querySelector('[data-cart-recs-scroller]')
    if (scroller && scroller.getAttribute('data-bound') !== 'true') {
      scroller.setAttribute('data-bound', 'true')
      scroller.addEventListener(
        'scroll',
        function () {
          updateProgress(root)
        },
        { passive: true }
      )
    }
    root.querySelectorAll('.cart-recs__card').forEach(syncCard)
    updateProgress(root)
  }

  function bindAll() {
    document.querySelectorAll('[data-cart-recs]').forEach(initRoot)
  }

  async function addFromCard(button) {
    var card = button.closest('.cart-recs__card')
    if (!card || button.classList.contains('is-loading')) return

    syncCard(card)
    var variantId = button.getAttribute('data-variant-id')
    var qtyState = getQtyState(card)
    if (!variantId) return

    var cart =
      document.querySelector('cart-drawer') ||
      document.querySelector('cart-notification')

    button.classList.add('is-loading')
    button.setAttribute('disabled', 'disabled')

    var formData = new FormData()
    formData.append('id', variantId)
    formData.append('quantity', String(qtyState.quantity))
    if (qtyState.percentOff > 0) {
      formData.append('properties[_pair_discount_percent]', String(qtyState.percentOff))
      formData.append('properties[Bundle]', qtyState.quantity + ' pairs')
    }

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id
        })
      )
      formData.append('sections_url', window.location.pathname)
    }

    try {
      var config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : {
              method: 'POST',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/javascript'
              }
            }
      delete config.headers['Content-Type']
      config.body = formData

      var response = await fetch(window.routes?.cart_add_url || '/cart/add', config)
      var data = await response.json()
      if (data.status) {
        console.error(data.description || data.message)
        return
      }

      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty')
        cart.renderContents(data)
      } else {
        window.location.href = window.routes?.cart_url || '/cart'
      }
    } catch (error) {
      console.error('Cart recs add failed', error)
    } finally {
      button.classList.remove('is-loading')
      button.removeAttribute('disabled')
      setTimeout(bindAll, 80)
    }
  }

  document.addEventListener('change', function (event) {
    var card = event.target.closest('.cart-recs__card')
    if (!card) return
    if (
      event.target.matches('[data-cart-rec-variant], select[data-cart-rec-qty]')
    ) {
      syncCard(card)
    }
  })

  document.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-cart-rec-qty-pill]')
    if (pill) {
      event.preventDefault()
      var card = pill.closest('.cart-recs__card')
      if (!card) return
      setPairQty(
        card,
        parseInt(pill.getAttribute('data-qty'), 10) || 1,
        parseFloat(pill.getAttribute('data-percent-off') || '0') || 0
      )
      return
    }

    var button = event.target.closest('[data-cart-rec-add]')
    if (!button) return
    event.preventDefault()
    addFromCard(button)
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll)
  } else {
    bindAll()
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(bindAll, 120)
    })
  }
})()
